export interface Key {
    key: string;
    code: string;
}

export const Escape: Key = {
    key: 'Escape',
    code: 'Esc',
};

export const PageUp: Key = {
    key: 'PageUp',
    code: 'Numpad9',
};

export const PageDown: Key = {
    key: 'PageDown',
    code: 'Numpad3',
};

export const Enter = {
    key: 'Enter',
    code: 'Enter',
};

export const Space: Key = {
    key: ' ',
    code: 'Space',
};

export const Backspace: Key = {
    key: 'Backspace',
    code: 'Backspace',
};

export const Delete: Key = {
    key: 'Delete',
    code: 'Delete',
};

export const Home: Key = {
    key: 'Home',
    code: 'Home',
};

export const End: Key = {
    key: 'End',
    code: 'End',
};

export const ArrowRight: Key = {
    key: 'ArrowRight',
    code: 'ArrowRight',
};

export const ArrowLeft: Key = {
    key: 'ArrowLeft',
    code: 'ArrowLeft',
};

export const ArrowUp: Key = {
    key: 'ArrowUp',
    code: 'ArrowUp',
};

export const ArrowDown: Key = {
    key: 'ArrowDown',
    code: 'ArrowDown',
};

export const Tab: Key = {
    key: 'Tab',
    code: 'Tab',
};

export const DigitKeys: Key[] = [
    {
        key: '0',
        code: 'Digit0',
    },
    {
        key: '1',
        code: 'Digit1',
    },
    {
        key: '2',
        code: 'Digit2',
    },
    {
        key: '3',
        code: 'Digit3',
    },
    {
        key: '4',
        code: 'Digit4',
    },
    {
        key: '5',
        code: 'Digit5',
    },
    {
        key: '6',
        code: 'Digit6',
    },
    {
        key: '7',
        code: 'Digit7',
    },
    {
        key: '8',
        code: 'Digit8',
    },
    {
        key: '9',
        code: 'Digit9',
    },
];
